import { IPAMaths } from '../../../../../../../lib';

type OfferInlineMetricsRow = {
  cost?: number | null;
  retail_price?: number | null;
  avg_competitiveness_price?: number | null;
  sales_tax_percentage?: number | null;
  expenses_percent?: number | null;
  salesTaxPercentage?: number | null;
  expensesPercent?: number | null;
};

export const getOfferInlineMetrics = (rowData: OfferInlineMetricsRow, price: number | null) => {
  const competitorPrice = rowData.avg_competitiveness_price ?? null;
  const retailPrice = rowData.retail_price ?? null;
  const retailPriceCpi =
    retailPrice !== null && retailPrice !== undefined && competitorPrice ? IPAMaths.novaCompetitividade(retailPrice, competitorPrice) : null;
  const offerPriceCpi = price !== null && price !== undefined && competitorPrice ? IPAMaths.novaCompetitividade(price, competitorPrice) : null;
  const salesTaxPercentage = rowData.sales_tax_percentage ?? rowData.salesTaxPercentage ?? 0;
  const expensesPercent = rowData.expenses_percent ?? rowData.expensesPercent ?? 0;

  return {
    margin: IPAMaths.novaMargem(price, salesTaxPercentage, expensesPercent, rowData.cost ?? 0) ?? 0,
    retail_price_cpi: retailPriceCpi,
    offer_price_cpi: offerPriceCpi,
  };
};
